
import React from 'react';
import actions from '../actions/UsTodniKamkarAction';
import Avatar from 'react-avatar';
var constants = require("../constants/constants");
var axios = require('axios');
const trStyle = { fontSize: '12px' }
var trstyle = {
    float: 'right',
    margin: '10px 10px 0px 0px'
}

export default class UstodaniMukadamachiMahiti extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            MukadamId: props.location.isEditCall ? props.location.editMukadamData.MukadamId : '',
            fname: props.location.isEditCall ? props.location.editMukadamData.FirstName : '',
            mname: props.location.isEditCall ? props.location.editMukadamData.MiddleName : '',
            lname: props.location.isEditCall ? props.location.editMukadamData.LastName : '',
            gender: props.location.isEditCall ? props.location.editMukadamData.Gender : '',
            addr: props.location.isEditCall ? props.location.editMukadamData.Address : '',
            village: props.location.isEditCall ? props.location.editMukadamData.Village : '',
            Taluka: props.location.isEditCall ? props.location.editMukadamData.Taluka : '',
            Distric: props.location.isEditCall ? props.location.editMukadamData.Distric : '',
            States: props.location.isEditCall ? props.location.editMukadamData.States : '',
            pincode: props.location.isEditCall ? props.location.editMukadamData.Pincode : '',
            contact: props.location.isEditCall ? props.location.editMukadamData.ContactNo : '',
            AlteNativecontact: props.location.isEditCall ? props.location.editMukadamData.AlteNativecontact = '0' : '',
            AdharCardNo: props.location.isEditCall ? props.location.editMukadamData.AdharCardNo : '',
            userPhoto: props.location.isEditCall ? props.location.editMukadamData.userPhoto : "images/img_avatar.png",
            TalukaList: [],
            DistrictList: [],
            StateList: [],
            CompanyId: CompanyId,
        };

        this.onImageChange.bind(this);

        //  this.getMukadamInfo = this.getMukadamInfo.bind(this);
    }

    addMukadam(e, CompanyId) {
        e.preventDefault();
        if (this.validation())
            actions.addMukadam(this.state, CompanyId);
        else
            return false;
        this.props.history.push('/MukadamFillInfo_Show_Details')
    }

    UpdateMukadam(e) {
        e.preventDefault();
        actions.UpdateMukadam(this.state);
        this.props.history.push('/MukadamFillInfo_Show_Details')
    }

    componentWillMount() {
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_DISTRICLIST, {
        }).then(function (response) {
            currentComponent.setState({ DistrictList: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        })
        axios.get(constants.config.HOST + constants.api.GET_TALUKALIST, {
        }).then(function (response) {
            currentComponent.setState({ TalukaList: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    onImageChange(event) {
        console.log('On Image change')
        var selectedFile = event.target.files;
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ userPhoto: e.target.result, selectedUserPhoto: selectedFile[0] });
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    selectImage(e) {
        e.preventDefault();
        this.myInput.click()
    }

    validation() {
        var validator = true;
        var errmsg = '';
        // remove already error element
        try {
            var elements = document.getElementsByClassName('help-block');
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        } catch (e) {
        }
        //validation code start
        var form = document.getElementById('theForm');
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
                errmsg = '';
                errmsg = form.elements[i].getAttribute("data-msg");
                if (errmsg != '') {
                    var ele = document.createElement("span");
                    ele.classList.add('help-block');
                    ele.textContent = errmsg;
                    form.elements[i].parentElement.appendChild(ele);
                }
                form.elements[i].parentElement.classList.add("has-error");
                validator = false;
            }
            else {
                form.elements[i].parentElement.classList.remove("has-error")
            }
        }
        return validator;
    }
    
    render() {
        let currentComponent = this;
        let distric = this.state.DistrictList.find(function (district) {
            return district.DistrictId == currentComponent.state.Distric
        });
        let taluka = this.state.TalukaList.find(function (Taluka) {
            return Taluka.TalukaId == currentComponent.state.Taluka
        });
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div className="page_single layout_fullwidth_padding">
                                <div className="contactform">
                                    <form className="" id="CustomForm" method="post" action="">
                                        <h3 style={{ 'color': '#0000FF' }}>ऊस तोडणी मुकादमाची माहिती </h3>
                                        <div>
                                            <Avatar img src={this.state.userPhoto != '' ? this.state.userPhoto : "images/img_avatar.png"} id="userPhoto" name="userPhoto" data-msg=" **** फोटो  आवश्यक ***" required />
                                            {/* <img src={this.state.userPhoto} alt="मुकादम image" id="userPhoto"  data-msg=" **** फोटो  आवश्यक ***" name="userPhoto" /> */}
                                        </div>
                                        <div>
                                            <input id="myInput" data-msg=" **** फोटो  आवश्यक ***" type="file"
                                                ref={(ref) => this.myInput = ref}
                                                onChange={(e) => this.onImageChange(e)}
                                                style={{ display: 'none' }} />
                                            <button className="btn  btn-primary" onClick={(e) => this.selectImage(e)}>Upload photo</button>
                                        </div>
                                        <form id="theForm">
                                            <fieldset>
                                                <div className="form_row">
                                                    <label>पहिले  नाव :</label>
                                                    <input type="text" className="form_input" id="fname" name="fname" data-msg=" **** पहिले नाव आवश्यक ***" value={this.state.fname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="पहिले  नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="mname">मधले  नाव :</label>
                                                    <input type="text" className="form_input" id="mname" name="mname" data-msg=" **** मधिले नाव आवश्यक ***" value={this.state.mname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="मधिले नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="lname">आडनाव :</label>
                                                    <input type="text" className="form_input" id="lname" name="lname" data-msg=" **** आडनाव आवश्यक ***" value={this.state.lname} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="आडनाव भरा" required />
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href="#" className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>Gender :</label>
                                                                <div className="item-after">Select</div>
                                                            </div>
                                                        </div>
                                                        <select id='gender' className="required" name='gender' value={this.state.gender} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Select</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                    </a>
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="addr">पत्ता :</label>
                                                    <input type="text" className="form_input" id="addr" name="addr" data-msg=" **** पत्ता आवश्यक ***" value={this.state.addr} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="पत्ता भरा" required />
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href="#" className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>जिल्हा नाव :</label>
                                                                <div className="item-after">{distric == undefined ? 'Select' : distric.DistrictName}</div>
                                                            </div>
                                                        </div>
                                                        <select id='Distric' className="required" name='Distric' value={this.state.District} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0" >Select</option>
                                                            {
                                                                this.state.DistrictList.map(district => <option value={district.DistrictId}>{district.DistrictName}</option>)
                                                            }
                                                        </select>
                                                    </a>
                                                </div>
                                                <div className="form_row custom_select">
                                                    <a href="#" className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>तालुका  नाव :</label>
                                                                <div className="item-after">{taluka == undefined ? 'Select' : taluka.TalukaName}</div>
                                                            </div>
                                                        </div>
                                                        <select id='Taluka' className="required" name='Taluka' value={this.state.Taluka} onChange={(e) => this.handleInputChange(e)}>
                                                            <option value="0">Select</option>
                                                            {
                                                                this.state.TalukaList.map(Taluka => <option value={Taluka.TalukaId}>{Taluka.TalukaName}</option>)
                                                            }
                                                        </select>
                                                    </a>
                                                </div >
                                                <div className="form_row">
                                                    <label>गावाचे नाव :</label>
                                                    <input type="text" className="form_input" id="village" data-msg=" **** गावाचे नाव आवश्यक ***" name="village" value={this.state.village} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="गावाचे नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="States">राज्याचे  नाव :</label>
                                                    <input type="text" className="form_input" id="State" data-msg=" **** राज्याचे  नाव आवश्यक ***" name="States" value={this.state.States} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="राज्याचे  नाव भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label > गावाचा पिनकोड :</label>
                                                    <input type="Number" className="form_input" id="pincode" data-msg=" **** गावाचा पिनकोड आवश्यक ***" name="pincode" value={this.state.pincode}
                                                        onChange={(e) => this.handleInputChange(e)} placeholder="गावाचा पिनकोड भरा " required />
                                                </div>
                                                <div className="form_row">
                                                    <label>मोबाईल नंबर :</label>
                                                    <input type="Number" className="form_input" id="contact" data-msg=" **** मोबाईल न. आवश्यक ***" name="contact" value={this.state.contact} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="मोबाईल न.भरा" required />
                                                </div>
                                                <div className="form_row">
                                                    <label htmlFor="AdharCardNo">आधार कार्ड नंबर :</label>
                                                    <input type="Number" className="form_input" id="AdharCardNo" data-msg=" **** आधार कार्ड न. आवश्यक ***" name="AdharCardNo" value={this.state.AdharCardNo} onChange
                                                        ={(e) => this.handleInputChange(e)} placeholder="आधार कार्ड न.भरा" required />
                                                </div>
                                                <br />
                                                <div className="form-group">
                                                    {this.props.location.isEditCall ? <button className="btn  btn-primary" style={trstyle} type="submit" onClick={(e) => this.UpdateMukadam(e)}>Update करा </button>
                                                        : <button className="btn  btn-primary" style={trstyle} type="submit" onClick={(e) => this.addMukadam(e, currentComponent.state.CompanyId)}>✔ Save करा </button>}
                                                </div>
                                            </fieldset>
                                        </form>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/component/UstodaniMukadamachiMahiti.jsx